export default __webpack_public_path__ + "static/media/IMG_1557212494339.d11d9d60.jpg";